const cohortDetails = {
  revenue_growth: {
    title: 'Revenue growth',
    description:
      'Review key metrics related to revenue, Average order value (AOV), and Average revenue per user (ARPU) growth over time.',
    presets: {
      overall_metrics: [
        'num_buyers',
        'num_orders',
        'gross_revenue',
        'aov',
        'arpu',
      ],
      lapse_metric: 'arpu',
    },
  },
  repeat_purchase: {
    title: 'Repeat purchase',
    description:
      'Examine repeat purchase %, avg. number of orders (ANO), and purchase cycles.',
    presets: {
      overall_metrics: [
        'num_buyers',
        'num_repeat',
        'repeat_perc',
        'ano',
        'arpu',
      ],
      lapse_metric: 'repeat_perc',
    },
  },
  churn_rate: {
    title: 'Churn rate',
    description:
      'Understand customer churn rate and avg. tenure to improve customer retention.',
    presets: {
      overall_metrics: [
        'num_buyers',
        'num_churned',
        'churned_perc',
        // 'avg_tenure',
        'arpu',
      ],
      lapse_metric: 'churned_perc',
    },
  },
};

export function getCohortDetails(cohort: keyof typeof cohortDetails) {
  if (cohort in cohortDetails) {
    return cohortDetails[cohort];
  }
}
